/**
 * Shared entity ID formatting utility.
 * All modules use BIGINT auto-increment IDs in the database;
 * these display helpers add a human-readable prefix.
 */

export type EntityType = "suite" | "plan" | "run" | "cycle";

const PREFIXES: Record<EntityType, string> = {
  suite: "SUIT",
  plan: "TP",
  run: "RUN",
  cycle: "CY",
};

export function formatEntityId(type: EntityType, id: number | string): string {
  return `${PREFIXES[type]}-${String(id).padStart(4, "0")}`;
}

/**
 * Format a run ID with its plan context and sequence number.
 * e.g. "TP-2878-Run #3"
 * Falls back to "RUN-0383" if planId or sequence is unavailable.
 */
export function formatRunLabel(
  planId: number | string | undefined | null,
  runSequence: number | undefined | null,
): string {
  if (planId && runSequence) {
    return `${formatEntityId("plan", planId)}-Run #${runSequence}`;
  }
  return "";
}
